import { css } from 'styled-components';
import rose from '../../images/rose_75x73.png';
import {
  colors,
  breakpoints,
  fonts,
  rosebud
} from '../../style-utilities/variables';

export default css`
  .checkbox-button__input:checked + .checkbox-button__control:after {
    top: 5.4px;
    left: 4.4px;
  }
  .review-watch, .hero-recipe-info{
    display:none;
  }

  #shopping-list-open {
    right: -65px !important;
  }
  #hero-section {
    .hero-recipe {
      h1 {
        font-size: 30px;
        font-family: ${fonts.primary}, 'sans-serif';
        text-align: center;
      }
    }
  }
  .small-img {
    background-image: url(${rose});
    height: ${rosebud.height};
    width: ${rosebud.width};
    background-repeat: no-repeat;
    background-size: cover;
    margin: 0 auto;
  }
  .widget-section {
    .button {
      border: ${colors.primary} 1px solid;
      background: white;
      color: ${colors.primary};
      font-weight: bold;
      svg {
        width: 25px;
        fill: ${colors.primary} !important;
      }
      &:hover {
        background: ${colors.primary};
        color: ${colors.white};
      }
    }
    a svg {
      fill: ${colors.primary} !important;
    }
  }
  .recipe-sub-nav {
    top: 75px;
    background: ${colors.primary};
  }
  .recipe-sub-nav .sub-nav-container .nav-item {
    color: ${colors.white} !important;
    svg {
      fill: ${colors.white} !important;
    }
  }
  #ingredient-section{
    .ingredients{
      h2{
        font-size:36px;
         margin-bottom: 0.2em;
         font-family: ${fonts.primary};
      }
    }
  }
  .ingredient-container {
    .product-image {
      img {
        margin: 0 auto !important;
      }
      #product-title {
        color: ${colors.primary};
        font-weight: bolder;
        font-size: 25px!important;
      }
    }
  }
  #deselect-button, .add-to-list, #tags{
    font-weight: bold;
  }

  #instruction-container {
    .title-instructions {
      font-size:36px;
         margin-bottom: 0.2em;
         font-family: ${fonts.primary};
    }
    .button-container {
      .pin-link,.button,
      .white-button {
        border: ${colors.white} 1px solid !important;
        background: white;
        color: ${colors.primary};
        /* &:hover {
          background: ${colors.white};
          color: ${colors.primary};
        } */
      }
    }
  }
  @media (max-width: ${breakpoints.tablet}) {
    .recipe-sub-nav {
      top: 130px !important;
    }
    .ingredient-container {
      .ingredients {
        padding: 25px 0 !important;
      }
      .product-image {
        margin-top: 0 !important;
      }
      h2{
        font-size: 36px;
      }
    }
  }
  .related-section-wrapper{
    h1{
      font-size:36px;
         margin-bottom: 0.2em;
         font-family: ${fonts.primary};
    }
    #related-recipes {
    margin: 0 auto;
    text-align: center;
  }
  }
`;
